import { ENVS } from './consts';

const INTERNAL_ENVS = [ENVS.STAGING, ENVS.NIGHTLY];

const cloudinaryDomainSuffix = '.cloudinary.com';

const getCloudinarySubDomain = () => {
  const hostname = window?.location?.hostname || '';
  return hostname.endsWith(cloudinaryDomainSuffix) ? hostname.split('.')[0] : null;
};

const getEnvNameFromSubDomain = (subDomain) => {
  return subDomain.match(/([^-]+)$/)?.[1];
};

const getInternalEnvironmentName = () => {
  const subDomain = getCloudinarySubDomain();

  if (subDomain) {
    const fullEnvName = getEnvNameFromSubDomain(subDomain);

    const envType = INTERNAL_ENVS.find((env) =>
      fullEnvName.match(`-${env}\\d*`) || fullEnvName.match(`^${env}\\d*`));

    return envType ? { fullEnvName, envType } : {};
  }

  return {};
};

/**
 * for the current URL will figure out the internal environment type ("staging" or "nightly")
 * examples:
 *  https://staging.cloudinary.com -> staging
 *  https://upload-widget-staging2.cloudinary.com -> staging
 *  https://media-editor-nightly.cloudinary.com/ -> nightly
 *  https://media-editor-nightly4.cloudinary.com/ -> nightly
 */
export const getEnvTypeFromUrl = () => {
  const { envType } = getInternalEnvironmentName();

  return envType;
};

/**
 * figures out the cloudinary environment based on the URL currently loaded in
 * In case NODE_ENV = "development", the env will always be development
 * examples:
 *  https://www.cloudinary.com/ -> production
 *  https://staging.cloudinary.com -> staging
 *  https://staging14.cloudinary.com -> staging14
 *  https://nightly2.cloudinary.com -> nightly2
 */
const getEnvFromUrl = () => {
  if (process.env.NODE_ENV === ENVS.DEVELOPMENT) {
    return ENVS.DEVELOPMENT;
  }

  const { fullEnvName } = getInternalEnvironmentName();

  // eslint-disable-next-line no-undef
  return fullEnvName || APP_ENV || ENVS.PRODUCTION;
};

export default getEnvFromUrl;
